import { useState } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { SubmitHandler, useForm } from "react-hook-form";

import Button from "../../components/Button";
import TextInput from "../../components/TextInput";
import { showToast } from "../../utils/toast";
import { apiClient } from "../../services/api";
import { ApiRoutes, routePaths } from "../../constants";
import { parseError } from "../../utils";
import { logError } from "../../utils/sentry";

interface FormProps {
  email: string;
}

export const Route = createFileRoute("/_auth/forgotPassword")({
  component: ForgotPassword,
});

function ForgotPassword() {
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit: SubmitHandler<FormProps> = async ({ email }) => {
    setIsLoading(true);
    try {
      await apiClient.post({
        url: ApiRoutes.FORGOT_PASSWORD,
        body: { email },
      });
      showToast("Check your email for password reset instructions.", "success");
    } catch (error: unknown) {
      const message = parseError(error);
      showToast(message, "error");
      logError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormProps>({ mode: "onSubmit", reValidateMode: "onChange" });

  return (
    <div>
      <h1 className="uppercase text-center text-gray-600">
        Request Password Reset
      </h1>

      <form className="my-6" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-control mb-8 w-96">
          <label className="block w-100 uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
            Email
          </label>
          <TextInput
            className="px-6 py-3 rounded-lg"
            {...register("email", { required: "Email Address is required " })}
            placeholder="Email"
            error={errors.email}
          />
        </div>
        <Button
          className="bg-primary hover:bg-accent transition-colors  text-white w-full py-3 ml-1 hover:border-accent rounded-lg border-primary"
          type="submit"
          disabled={isLoading}
        >
          Reset Password
        </Button>
        <div className="text-black text-center mt-5">
          <Link to={routePaths.login} className="text-primary">
            ← Back to Login
          </Link>
        </div>
      </form>
    </div>
  );
}
